module.exports = "/_next/static/images/ca6aee47d96ebcac7bd2383ca78a29b4-credit-card-perks-xs-1x.png.webp";